import { motion } from "framer-motion";
import { Apple, Play, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { APP_LINKS } from "@/constants/appLinks";

// Real store buttons when a link is configured; otherwise a clean Coming Soon
// state (never a dead link).
export const StoreButtons = ({ className = "", size = "md" }) => {
  const pad = size === "lg" ? "px-7 py-4" : "px-6 py-3.5";
  const comingSoon = (store) =>
    toast(`${store} — launching soon`, { description: "The app will be available here shortly." });

  const appStore = APP_LINKS.appStore
    ? { href: APP_LINKS.appStore, target: "_blank", rel: "noopener noreferrer" }
    : { role: "button", onClick: () => comingSoon("App Store") };
  const play = APP_LINKS.googlePlay
    ? { href: APP_LINKS.googlePlay, target: "_blank", rel: "noopener noreferrer" }
    : { role: "button", onClick: () => comingSoon("Google Play") };

  return (
    <div className={`flex flex-col items-center gap-3 sm:flex-row ${className}`}>
      <motion.a
        {...appStore}
        data-testid="cta-app-store"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.98 }}
        className={`group flex w-full cursor-pointer items-center gap-3 rounded-full bg-white ${pad} text-left text-zinc-950 shadow-[0_8px_40px_-10px_rgba(255,255,255,0.4)] sm:w-auto`}
      >
        <Apple className="h-6 w-6" fill="currentColor" strokeWidth={0} />
        <span className="leading-none">
          <span className="block text-[10px] uppercase tracking-widest opacity-70">Download on the</span>
          <span className="block font-display text-lg font-semibold">App Store</span>
        </span>
      </motion.a>
      <motion.a
        {...play}
        data-testid="cta-google-play"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.98 }}
        className={`group relative flex w-full cursor-pointer items-center gap-3 overflow-hidden rounded-full border border-white/15 bg-white/5 ${pad} text-left text-white backdrop-blur-xl transition-colors duration-300 hover:border-indril-saffron/50 hover:bg-white/10 sm:w-auto`}
      >
        <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
        <Play className="h-6 w-6 text-indril-saffron" fill="currentColor" strokeWidth={0} />
        <span className="leading-none">
          <span className="block text-[10px] uppercase tracking-widest opacity-70">Get it on</span>
          <span className="block font-display text-lg font-semibold">Google Play</span>
        </span>
      </motion.a>
    </div>
  );
};

export const StoreBadgeMini = () => (
  <span className="inline-flex items-center gap-1.5 text-xs text-white/50">
    <Sparkles className="h-3.5 w-3.5 text-indril-saffron" /> Available on iOS &amp; Android
  </span>
);
